import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const items = [
  { label: '首页', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', to: '/' },
  { label: '搜索', icon: 'ri-search-line', activeIcon: 'ri-search-eye-line', to: '/search' },
  { label: '收藏', icon: 'ri-heart-3-line', activeIcon: 'ri-heart-3-fill', to: '/favorites' },
  { label: '关于', icon: 'ri-information-line', activeIcon: 'ri-information-fill', to: '/about' },
];

export default function MobileNav() {
  const location = useLocation();
  const [sheetOpen, setSheetOpen] = useState(false);

  const isActive = (to: string) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);
  const categoryActive = location.pathname.startsWith('/category');

  return (
    <>
      {sheetOpen && (
        <div
          className="fixed inset-0 z-[60] bg-black/60 lg:hidden"
          onClick={() => setSheetOpen(false)}
        >
          <div
            className="absolute bottom-16 left-0 right-0 animate-fade-up rounded-t-2xl border-t border-background-200 bg-background-100 p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-3 flex items-center justify-between">
              <p className="font-heading text-sm font-semibold text-foreground-950">选择分类</p>
              <button
                type="button"
                onClick={() => setSheetOpen(false)}
                className="flex h-8 w-8 items-center justify-center rounded-full bg-background-200 text-foreground-700"
              >
                <i className="ri-close-line" />
              </button>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((c) => (
                <Link
                  key={c.id}
                  to={`/category/${c.id}`}
                  onClick={() => setSheetOpen(false)}
                  className="flex items-center gap-2 rounded-lg bg-background-50 px-3 py-3 text-sm text-foreground-800"
                >
                  <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-500/15 text-secondary-300">
                    <i className={`${c.icon} text-sm`} />
                  </span>
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}

      <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-background-200 bg-background-50/95 backdrop-blur-md lg:hidden">
        <div className="grid grid-cols-5">
          <Link to="/" className={`flex flex-col items-center gap-0.5 py-2.5 text-[11px] ${isActive('/') ? 'text-primary-300' : 'text-foreground-500'}`}>
            <i className={`${isActive('/') ? 'ri-home-5-fill' : 'ri-home-5-line'} text-xl`} />
            首页
          </Link>
          <button
            type="button"
            onClick={() => setSheetOpen((v) => !v)}
            className={`flex flex-col items-center gap-0.5 py-2.5 text-[11px] ${categoryActive || sheetOpen ? 'text-primary-300' : 'text-foreground-500'}`}
          >
            <i className={`${categoryActive ? 'ri-apps-2-fill' : 'ri-apps-2-line'} text-xl`} />
            分类
          </button>
          <Link to="/search" className={`flex flex-col items-center gap-0.5 py-2.5 text-[11px] ${isActive('/search') ? 'text-primary-300' : 'text-foreground-500'}`}>
            <i className={`${isActive('/search') ? 'ri-search-eye-line' : 'ri-search-line'} text-xl`} />
            搜索
          </Link>
          <Link to="/favorites" className={`flex flex-col items-center gap-0.5 py-2.5 text-[11px] ${isActive('/favorites') ? 'text-primary-300' : 'text-foreground-500'}`}>
            <i className={`${isActive('/favorites') ? 'ri-heart-3-fill' : 'ri-heart-3-line'} text-xl`} />
            收藏
          </Link>
          <Link to="/about" className={`flex flex-col items-center gap-0.5 py-2.5 text-[11px] ${isActive('/about') ? 'text-primary-300' : 'text-foreground-500'}`}>
            <i className={`${isActive('/about') ? 'ri-information-fill' : 'ri-information-line'} text-xl`} />
            关于
          </Link>
        </div>
      </nav>
    </>
  );
}